import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M7.78,4.85,5.28,3.18a.52.52,0,0,0-.56,0L2.22,4.85A.5.5,0,0,0,2,5.27V9.5a.5.5,0,0,0,.5.5H4V7H6v3H7.5A.5.5,0,0,0,8,9.5V5.27A.5.5,0,0,0,7.78,4.85Z"/><path d="M28.88,8H14.12A1.07,1.07,0,0,1,13,7a1.07,1.07,0,0,1,1.12-1H28.88A1.07,1.07,0,0,1,30,7,1.07,1.07,0,0,1,28.88,8Z"/><path d="M7.78,13.85l-2.5-1.67a.52.52,0,0,0-.56,0l-2.5,1.67a.5.5,0,0,0-.22.42V18.5a.5.5,0,0,0,.5.5H4V16H6v3H7.5a.5.5,0,0,0,.5-.5V14.27A.5.5,0,0,0,7.78,13.85Z"/><path d="M28.88,17H14.12a1,1,0,1,1,0-2H28.88a1,1,0,1,1,0,2Z"/><path d="M7.78,22.85l-2.5-1.67a.52.52,0,0,0-.56,0l-2.5,1.67a.5.5,0,0,0-.22.42V27.5a.5.5,0,0,0,.5.5H4V25H6v3H7.5a.5.5,0,0,0,.5-.5V23.27A.5.5,0,0,0,7.78,22.85Z"/><path d="M28.88,26H14.12a1,1,0,1,1,0-2H28.88a1,1,0,1,1,0,2Z"/>';
export var MLSOutlineSVG = function MLSOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
MLSOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(MLSOutlineSVG);